import Stack from "@mui/material/Stack";
import InputField from "Components/Shared/textField";
import Box from "@mui/material/Box";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "Components/Shared/button";

import Progress from "Components/Shared/loading";
import DialogComponent from "Components/Shared/dailog";
import { useForm } from "Utils/hooks";
import { request } from "Utils";
import { useState } from "react";
import { useMutation } from "react-query";
import { AddFunc } from "./type";

const Add: AddFunc = ({ toggleToast, isOpen, closeDialog, refetch }) => {
  const { getData, values, submit, reset } = useForm(submitForm);
  const [isLoading, setIsloading] = useState(false);

  const mutation = useMutation(
    async () => {
      setIsloading(true);
      if (values.country) values.country = values.country.toLowerCase();
      values.hashtags = [{ hashtag: values.hashtags }];
      return await request.post({
        url: "/supportgroups/",
        data: values
      });
    },
    {
      onSuccess: ({ message }) => {
        reset();
        toggleToast(message);
        refetch();
        setIsloading(false);
        closeDialog();
      },
      onError: ({ message }) => {
        toggleToast(message);
        setIsloading(false);
      }
    }
  );

  function submitForm() {
    mutation.mutate();
  }

  return (
    <div>
      <DialogComponent
        open={isOpen}
        onClose={closeDialog}
        title="Add new support"
        maxWidth="sm"
      >
        <form onSubmit={submit}>
          <Stack spacing={4} py={5}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <InputField
                type="text"
                label="Name"
                name="name"
                onChange={getData}
                sx={{ width: { xs: "100%", sm: "49%" } }}
                required
              />
              <InputField
                type="text"
                label="Hashtags"
                name="hashtags"
                onChange={getData}
                sx={{ width: { xs: "100%", sm: "49%" }, mt: { xs: 4, sm: 0 } }}
                required
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <InputField
                type="text"
                label="Country"
                name="country"
                onChange={getData}
                sx={{ width: { xs: "100%", sm: "49%" } }}
                required
              />
              <FormControl
                required
                sx={{ width: { xs: "100%", sm: "49%" }, mt: { xs: 4, sm: 0 } }}
              >
                <InputLabel id="demo-simple-select-label">Privacy</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.day}
                  label="Privacy"
                  // onChange={(e)=>getData(e)}
                >
                  <MenuItem value="monday">Public</MenuItem>
                  <MenuItem value="tuesday">Privacy</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <InputField
              type="text"
              label="Website"
              name="website"
              onChange={getData}
              required
            />
            <TextareaAutosize
              onChange={(e) => (values.bio = e.target.value)}
              placeholder="Typing bios"
              style={{ borderRadius: 5, padding: "20px" }}
              maxRows={4}
              required
            />

            <Button type="submit" variant="contained">
              Add support
              {isLoading && (
                <Progress sx={{ color: "#fff", ml: 0.8 }} size={18} />
              )}
            </Button>
          </Stack>
        </form>
      </DialogComponent>
    </div>
  );
};

export default Add;
